import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RunDeviceSignalDocument } from './run.generated';

export const useRunDeviceSignal = (options: ApiOptions<typeof RunDeviceSignalDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(RunDeviceSignalDocument, {
    ...useNotifications(RunDeviceSignalDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.device_signals.run_success'),
    }),
    ...options,
  });
};
